import { computed } from 'vue';
import { paymentOptions } from './salesPropertyFormOptions';

export function useSalesDetailCommission({ transaction, t }) {
  const profile = computed(() => transaction.value.profile || {});
  const plan = computed(() => transaction.value.commission_plan || {});
  const money = value => value?.amount || value;
  const paymentMethod = computed(() => {
    if (plan.value.forma_pagamento) return plan.value.forma_pagamento;

    const values = Array.isArray(profile.value.forma_pagamento)
      ? profile.value.forma_pagamento
      : String(profile.value.forma_pagamento || '')
          .split(',')
          .filter(Boolean);
    return values
      .map(
        value =>
          paymentOptions(t).find(option => option.value === String(value))
            ?.label || value
      )
      .join(', ');
  });
  const installments = computed(() => plan.value.parcelas_empresa || []);
  const allocationInstallments = computed(
    () => plan.value.parcelas_comissao || []
  );
  const responsibilities = computed(() =>
    allocationInstallments.value
      .flatMap(item => item.responsaveis_pagamento || [])
      .filter(item => item.papel === 'Vendedor')
  );
  const items = computed(() => [
    {
      key: 'total',
      label: t('SALES.DETAIL.COMMISSION.TOTAL'),
      value: money(
        plan.value.valor_comissao_total || profile.value.valor_comissao_total
      ),
    },
    {
      key: 'deduction',
      label: t('SALES.DETAIL.COMMISSION.DEDUCTION'),
      value: money(plan.value.deducao || profile.value.deducao),
    },
    {
      key: 'net',
      label: t('SALES.DETAIL.COMMISSION.NET'),
      value: money(
        plan.value.valor_comissao_liquida ||
          profile.value.valor_comissao_liquida
      ),
    },
    {
      key: 'payment',
      label: t('SALES.DETAIL.COMMISSION.PAYMENT'),
      value: paymentMethod.value,
    },
    {
      key: 'type',
      label: t('SALES.DETAIL.COMMISSION.TYPE'),
      value: plan.value.tipo_pagamento,
    },
    {
      key: 'installments',
      label: t('SALES.DETAIL.COMMISSION.INSTALLMENT_COUNT'),
      value: installments.value.length || null,
    },
  ]);

  return {
    allocationInstallments,
    installments,
    items,
    plan,
    profile,
    responsibilities,
  };
}
